import $ from 'jquery';

// When an image gallery thumbnail radio control is selected, the image gallery's main image is updated with the selected thumbnail's image data
$('.image-gallery').each(function() {
  const $mainImage = $(this).find('.image-gallery-image-main');
  const $thumbnailRadios = $(this).find('.image-gallery-thumbnail-radio');

  $thumbnailRadios.click(function() {
    const imageUrl = $(this).data('image-url');
    const imageText = $(this).data('image-text');

    $mainImage.attr('src', imageUrl);
    $mainImage.attr('alt', imageText);
  });
});